import { IRefIds } from 'constants/refs';
import { del, get, post } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IItemSourceMeanValidatorCreate, IItemSourceMeanValidatorEdit, IItemSourceMeanValidatorListItem } from 'types/itemSourceMeanValidator';
import { IKline } from '../types/klines';

export type ItemSourceMeanValidatorModelOptions = IModelOptions & {
  courseId: number;
};

export class ItemSourceMeanValidatorModel extends BaseModel<
  IItemSourceMeanValidatorListItem,
  IItemSourceMeanValidatorEdit
> {
  constructor(options: ItemSourceMeanValidatorModelOptions) {
    super(options);
    this.ref = IRefIds.itemSourceMeanValidator;
    this.gridName = 'ItemSourceMeanValidator';
    this.courseId = options.courseId;
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IItemSourceMeanValidatorListItem[]>(`/courses/${this.courseId}/item-source-mean-validator`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<IKline>(`/courses/${this.courseId}/item-source-mean-validator/${itemId}`);
  }

  async createJob(data: IItemSourceMeanValidatorCreate) {
    const response = await post<{ id: number; message: string }>(`/courses/${this.courseId}/item-source-mean-validator`, data);
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`item-source-mean-validator/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IItemSourceMeanValidatorEdit>(`item-source-mean-validator/${itemId}`);
  }
}